export const sources={};export const img={src:"__VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__",w:640,h:640};export default{sources:sources,img:img};